// extracted by mini-css-extract-plugin
export default {"container":"FormGdprCheckbox_container__NLv-C","checkmark":"FormGdprCheckbox_checkmark__vpR7P","error":"FormGdprCheckbox_error__sA0rS"};